module.exports = __webpack_public_path__ + "static/media/participles3_img.d51edd0e.JPG";